import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { primaryElementFont } from "app/pages/sales-intelligence/sub-modules/signals/components/filters/shared/styles";
import { StyledModalFooter } from "app/pages/sales-intelligence/sub-modules/signals/components/modals/SignalsModal/styles";
import { divider } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/styles";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledFiltersViewInner = styled(FlexColumn)`
    flex: 1 0 100%;

    ${StyledModalFooter} {
        width: 100%;
    }
`;

export const StyledFiltersViewContent = styled(FlexColumn)`
    flex: 1 0;
    row-gap: 16px;
    width: 100%;
    padding: 36px 56px 16px;
    box-sizing: border-box;
`;

export const StyledFiltersWrapper = styled(FlexRow)``;

const StyledFilterLabel = styled.span`
    ${primaryElementFont(colorsPalettes.carbon["500"])};

    margin-right: 8px;
    user-select: none;
`;

export const StyledFilterLabelLowercase = styled(StyledFilterLabel)`
    text-transform: lowercase;
`;

export const StyledNotificationWrapper = styled.div`
    margin-top: auto;
`;

export const StyledCountryButtonDd = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    line-height: 30px;
`;

export const StyledCountryButtonDDText = styled.div`
    margin-left: 4px;
`;

export const StyledCountryDDWrapper = styled.div`
    display: flex;
    width: fit-content;
`;

export const StyledItemsDivider = styled.div`
    ${divider};

    margin: 12px 10px;
    pointer-events: none;
`;

export const StyledInlineFilterWrapper = styled.div`
    display: inline-block;

    &:not(:last-child) {
        margin-right: 8px;
    }
`;

export const StyledDirectionIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 12px;
`;

export const StyledBannerText = styled.span`
    ${mixins.setFontVariant("sectionTitle", colorsPalettes.carbon["300"])};
`;
